export function getCurrentMonthYear() {
  return new Date()
    .toLocaleDateString("en", {
      year: "numeric",
      month: "2-digit",
    })
    .replace("/", "-")
}
